import React from "react";
import UpdateHeader from "./1_UpdateHeader/UpdateHeader";
import UpdateBody from "./2_UpdateBody/UpdateBody";
import UpdateNote from "./3_UpdateNote/UpdateNote";
import { HouseholdChangeContext } from "../HouseholdContext/HouseholdChangeContext";
import { AddressChangeContext } from "components/StraightThroughAddressComp/AddressContext/AddressChangeContext";
import { DriverHHMContextComp } from "../HouseholdContext/DriverHHMContext";

const HouseholdSummaryMain = () => {
  var screen = window.location.pathname.split("/").pop();
  
  var requestContext = screen?.includes("address")
    ? AddressChangeContext
    : HouseholdChangeContext;

  var endorsementType = screen?.includes("address")
    ? "Change Address"
    : "Change Household";

  return (
    <DriverHHMContextComp>
      <UpdateHeader/>
      <hr />
      <UpdateBody
        requestContext={requestContext}
        endorsementType={endorsementType}
      />
      <hr />
      <UpdateNote />
    </DriverHHMContextComp>
  );
};

export default HouseholdSummaryMain;
